import React from 'react';
import './PublicLayout.css';

interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return (
    <div className="public-layout">
      <header className="public-header">
        <div className="public-header-content">
          <div className="public-header-wrapper">
            <h1 className="public-logo">Clara</h1>
          </div>
        </div>
      </header>
      
      <main className="public-main">
        {children}
      </main>
      
      <footer className="public-footer">
        <div className="public-footer-content">
          <p>&copy; 2025 Clara. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default PublicLayout; 